import { SideNavigation as CloudscapeSideNavigation } from '@cloudscape-design/components';
import type { SideNavigationProps as CloudscapeSideNavigationProps } from '@cloudscape-design/components';
import './SideNavigation.css';

interface SideNavigationProps {
  activeHref: string;
  onFollow: (event: CustomEvent<CloudscapeSideNavigationProps.FollowDetail>) => void;
}

export function SideNavigation({ activeHref, onFollow }: SideNavigationProps) {
  const navigationItems: CloudscapeSideNavigationProps.Item[] = [
    {
      type: 'link',
      text: 'Playground',
      href: '/',
    },
    {
      type: 'section',
      text: 'Agents',
      items: [
        {
          type: 'link',
          text: 'My Agents',
          href: '/agents/my',
        },
        {
          type: 'link',
          text: 'Shared Agents',
          href: '/agents/shared',
        },
        {
          type: 'link',
          text: 'Published Agents',
          href: '/agents/published',
        },
      ],
    },
    {
      type: 'section',
      text: 'Telecom',
      items: [
        {
          type: 'link',
          text: 'Phone Number Inventory',
          href: '/telecom/phone-inventory',
        },
        {
          type: 'link',
          text: 'Dial Plan',
          href: '/telecom/dial-plan',
        },
        {
          type: 'link',
          text: 'SIP Servers',
          href: '/telecom/sip-servers',
        },
      ],
    },
    {
      type: 'section',
      text: 'Tooling',
      items: [
        {
          type: 'link',
          text: 'Local Tools',
          href: '/tooling/local-tools',
        },
        {
          type: 'link',
          text: 'MCP Servers',
          href: '/tooling/mcp-servers',
        },
      ],
    },
    {
      type: 'section',
      text: 'Analytics',
      items: [
        {
          type: 'link',
          text: 'Dashboard',
          href: '/analytics',
        },
        {
          type: 'link',
          text: 'Session History',
          href: '/history',
        },
      ],
    },
    {
      type: 'divider',
    },
    {
      type: 'link',
      text: 'Settings',
      href: '/settings',
    },
  ];

  return (
    <nav aria-label="Main navigation">
      <CloudscapeSideNavigation
        activeHref={activeHref}
        items={navigationItems}
        onFollow={onFollow}
        header={{
          text: 'Nova Sonic',
          href: '/',
        }}
      />
    </nav>
  );
}
